import { render, staticRenderFns } from "./interRecord.vue?vue&type=template&id=503ece02&scoped=true&"
import script from "./interRecord.vue?vue&type=script&lang=js&"
export * from "./interRecord.vue?vue&type=script&lang=js&"
import style0 from "./interRecord.vue?vue&type=style&index=0&id=503ece02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503ece02",
  null
  
)

export default component.exports